import { Controller } from '@hotwired/stimulus';

// Folds a repeating form row down to its heading. The gear editor and the price list wire it
// from profile_edits/_nested_rows.html.erb; what the folded line SAYS is row_heading's job, and
// the two are separate because a row can want a live heading without folding at all (the
// line-up editor does).
//
//   <details data-controller="row-card" data-row-card-fold-value="true" open>
//     <summary>...the heading...</summary>
//     <div>...the fields...</div>
//   </details>
//
// Whether a row starts folded is the server's call, not a guess made here: it knows which rows
// hold a validation error (those have to stay open - a form that comes back and hides its own
// message is worse than one that says nothing) and which are still blank.
//
// Progressive enhancement, the same bargain the other editors' controllers make: the server
// renders every row OPEN and this folds them, so with the bundle blocked the editor is what it
// was before folding existed. Nothing here is reachable only by unfolding.
export default class extends Controller {
  static values = { fold: Boolean };

  connect() {
    this.reveal = this.reveal.bind(this);
    // `invalid` does not bubble, so this listens on the way down. Without it a row folded over
    // a value the browser rejects kills the submit in silence: Chrome will not focus a control
    // inside a closed <details>, so it cancels and writes "not focusable" to the console while
    // the page just sits there.
    this.element.addEventListener('invalid', this.reveal, true);

    if (this.foldValue) this.element.open = false;
  }

  disconnect() {
    this.element.removeEventListener('invalid', this.reveal, true);
  }

  reveal() {
    this.element.open = true;
  }

  // The drag handle sits inside the <summary>, so its click reaches the fold on the way up and
  // would open the row somebody has just finished dragging.
  ignore(event) {
    event.preventDefault();
  }
}
